import { AppShell } from '@mantine/core'


interface MainLayoutProps {
    children: React.ReactNode
}

export function MainLayout({ children }: MainLayoutProps) {
    return (


        <AppShell.Main>
            {children}
        </AppShell.Main>

    )
} 